import React from 'react';
import { Redirect } from 'react-router-dom';
import { NEW_PLANNING_PROFILE_ID, NEW_PLANNING_PLUS_PROFILE_ID } from '../../constants/profile';

const entryRoutes = [
    [10, '/app/ciclo'],
    [3, '/app/draw'],
    [4, '/app/estimativa'],
    [NEW_PLANNING_PLUS_PROFILE_ID, '/app/planejamento'],
    [NEW_PLANNING_PROFILE_ID, '/app/planejamento-individual'],
    [11, '/app/qualidade'],
    [9, '/app/relatorio'],
    [6, '/app/location'],
    [7, '/app/cadastro/cliente/list'],
    [2, '/app/cadastro/empresa/list'],
    [1, '/app/updategps'],
];

export const getEntryRoute = (profile) => {
    const entry = entryRoutes.find(([id]) => profile.includes(id));
    return entry ? entry[1] : null;
};

export default function PermissionEntry({ profile, res, requiredProfileId, children }) {
    if (requiredProfileId && profile.includes(requiredProfileId)) return children;
    const destination = getEntryRoute(profile);
    return destination
        ? <Redirect to={destination} />
        : <div role="alert">{res.PERMISSAO_MSG}</div>;
}
